import SidebarGroup from "../sidebarGroup"
import useLayout from "hooks/useLayout"
import SidebarRow from "../SidebarRow"
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg'
import { ReactComponent as AddIcon } from 'assets/icons/add.svg'
import { ReactComponent as HistoryIcon } from 'assets/icons/restore.svg'
import RightSidebar from "./RightSidebar"
import { useTranslation } from "react-i18next"
import useAccess from "@/hooks/useAccess"
import { AccessRole } from "@/types"
import useLocations from "@/hooks/useLocations"
import { useState } from "react"
import { ReactComponent as RestoreIcon } from 'assets/icons/restore_from_trash.svg'

interface RightSidebarLocationProps {
    className?: string;
    children?: React.ReactNode;
    storageId?: string;
    locationId?: string;
}

const RightSidebarLocation: React.FC<RightSidebarLocationProps> = ({ className, children, storageId, locationId }) => {

    const { t } = useTranslation()
    
    const {
        limitToRoles
    } = useAccess({ storageId: storageId || '' })

    const {
        location,
        restoreLocationAsync,
        isRestoring
    } = useLocations({ storageId, locationId })

    const {
        openDialog,
        addToast
    } = useLayout()

    const [isRestoringState, setIsRestoringState] = useState(false)

    const handleRestoreClick = async () => {
        if (!storageId || !locationId) return
        setIsRestoringState(true)
        try {
            await restoreLocationAsync({
                storageId,
                locationId
            })
            addToast({
                text: t('locationRestored'),
                colorScheme: 'green'
            })
        } catch (error) {
            addToast({
                text: t('failedToRestore'),
                colorScheme: 'red'
            })
        } finally {
            setIsRestoringState(false)
        }
    }

    return (
        <RightSidebar storageId={storageId}>
            <SidebarGroup title={t('menuLocationActions')} allwaysOpen={true}>
            <SidebarRow onClick={() => openDialog('location_history')} text={t('buttonViewHistory')} icon={<HistoryIcon />} style={`border`} />
            {limitToRoles([AccessRole.OWNER, AccessRole.EDITOR]) && <>
                {!location?.isDeleted && (
                    <>
                        <SidebarRow 
                            to={`/storage/locations/create`}
                            state={{
                                locationId: locationId,
                            }} text={t('buttonNewChildLocation')} icon={<AddIcon />} style={`border`} />
                        <SidebarRow to={`/storage/locations/${locationId}/edit`} text={t('buttonEditLocation')} icon={<EditIcon />} style={`border`} />
                        <SidebarRow onClick={() => openDialog(`delete_location`, {storageId, locationId})} text={t('buttonDelete')} icon={<DeleteIcon />} style={`border`} />
                    </>
                )}
                {location?.isDeleted && (
                    <SidebarRow 
                        onClick={handleRestoreClick} 
                        text={isRestoring || isRestoringState ? t('restoringItem') : t('restoreLocation')} 
                        icon={<RestoreIcon />}
                        style={`border`} 
                    />
                )}
            </>}
            </SidebarGroup>
        </RightSidebar>
    )
}

export default RightSidebarLocation
